import { GetDateUSSemValue } from "src/shared/Utils/FormatDateBR";

import {
  IFilterInstallmentsReceived,
  IFilterProfitableValues,
} from "../ContextDashboardBrokerTypes";
import { FormatDateFirstDayYear } from "src/shared/Utils/FormatDate/FormatDateFirstDayYear";

export const valuesDefaultFilterProfitableValues: IFilterProfitableValues = {
  start_date: FormatDateFirstDayYear(),
  end_date: GetDateUSSemValue(),
  interval: "MONTH",
};

export const valuesDefaultInstallmentsReceived: IFilterInstallmentsReceived = {
  start_date: FormatDateFirstDayYear(),
  end_date: GetDateUSSemValue(),
  interval: "MONTH",
};
